import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'
import { Typography, TypingIndicator, Scrollbar, type IScrollbarsPropsRef } from 'shared/ui'
import type { ChatbotConversationMessage } from 'entities/Chatbot'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import styles from './styles.module.scss'

export const TestAgentMessages = observer(() => {
  const { testAgentStore } = useUnifiedAgentContext()
  const { messages, loading, shouldShowIncomingMessage, pendingUserMessage } = testAgentStore
  const scrollRef = useRef<IScrollbarsPropsRef | null>(null)

  useEffect(() => {
    if (!scrollRef.current) return
    scrollRef.current.scrollToBottom()
  }, [messages.length, loading, pendingUserMessage])

  const isUserMessage = (message: ChatbotConversationMessage) => message.type === 'user'

  return (
    <Scrollbar ref={scrollRef} viewClassName={styles.messagesView} indentX={16}>
      {messages.map((message) => (
        <div
          key={message.id}
          className={isUserMessage(message) ? styles.messageUser : styles.messageBot}
        >
          <Typography
            variant='body-rg-regular'
            ariaLabel='message'
            className={isUserMessage(message) ? styles.bubbleUser : styles.bubbleBot}
          >
            {message.body}
          </Typography>
        </div>
      ))}
      {pendingUserMessage && (
        <div className={styles.messageUser}>
          <Typography variant='body-rg-regular' ariaLabel='message' className={styles.bubbleUser}>
            {pendingUserMessage}
          </Typography>
        </div>
      )}
      {(loading || shouldShowIncomingMessage) && (
        <div className={styles.messageBot}>
          <span className={styles.typeIndicator}>
            <TypingIndicator className={styles.typingDot} />
          </span>
        </div>
      )}
    </Scrollbar>
  )
})
